<template>
  <div class="p-6">
    <!-- Sub-tabs -->
    <Page_Tabs
      :tabs="tabs"
      :initial-tab="activeTab"
      class="mb-4"
      @select="activeTab = $event"
    />

    <!-- Provider Roster Report -->
    <div v-show="activeTab === 'Provider Roster Report'" class="border border-gray-200 rounded-lg overflow-hidden">
      <ProviderRosterReport
        v-if="visited.includes('Provider Roster Report')"
        @preview-practice="previewProviderPractice"
      />
    </div>

    <!-- What a practice would see when asked to validate its providers -->
    <div v-show="activeTab === 'Practice Provider View'" class="border border-gray-200 rounded-lg overflow-hidden">
      <PracticeProviderView
        v-if="visited.includes('Practice Provider View')"
        :initial-practice="providerToPreview"
      />
    </div>
  </div>
</template>

<script>
import ProviderRosterReport from './ProviderRosterReport.vue'
import PracticeProviderView from './PracticeProviderView.vue'
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue'

export default {
  name: 'Rostering_Test',
  components: {
    ProviderRosterReport,
    PracticeProviderView,
    Page_Tabs,
  },
  data() {
    return {
      activeTab: 'Provider Roster Report',
      tabs: [
        'Provider Roster Report',
        'Practice Provider View',
      ],
      // Mount each tab's component only once opened, so nothing fetches until
      // the user asks for it.
      visited: ['Provider Roster Report'],
      providerToPreview: null,
    }
  },
  watch: {
    activeTab(tab) {
      if (!this.visited.includes(tab)) this.visited.push(tab)
    },
  },
  methods: {
    // Jump from a provider report row straight into that practice's provider view.
    previewProviderPractice(practiceEntityId) {
      this.providerToPreview = practiceEntityId
      this.openTab('Practice Provider View')
    },
    openTab(tab) {
      this.activeTab = tab
      if (!this.visited.includes(tab)) this.visited.push(tab)
    },
  },
}
</script>
